import React from 'react';
import { LEADERSHIP } from '../data';

export default function Leadership() {
  return (
    <section id="leadership" style={{ padding: '100px 0', borderTop: '1px solid rgba(26,26,26,0.06)' }}>
      <div style={{ padding: '0 12%' }}>
        <div className="fade-in" style={{ marginBottom: '56px' }}>
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.28em', color: 'var(--ink-mid)', textTransform: 'uppercase', marginBottom: '16px' }}>
            Leadership & Volunteering
          </div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 600, color: 'var(--ink)', lineHeight: 1, letterSpacing: '-0.03em', marginBottom: '12px' }}>
            Beyond the Code
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink-light)', fontWeight: 300 }}>
            Building isn't just about systems — it's about people, communities, and showing up.
          </p>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '0' }}>
          {LEADERSHIP.map((item, i) => (
            <div key={i} className="fade-in" style={{
              padding: '28px 32px',
              borderBottom: '1px solid rgba(26,26,26,0.06)',
              borderRight: '1px solid rgba(26,26,26,0.06)',
              position: 'relative',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '8px', flexWrap: 'wrap', gap: '8px' }}>
                <div style={{ fontFamily: 'var(--font-display)', fontSize: '18px', fontWeight: 600, color: 'var(--ink)', letterSpacing: '-0.01em' }}>
                  {item.role}
                </div>
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '9px', letterSpacing: '0.15em', color: item.period === 'Current' ? 'var(--accent)' : 'var(--ink-light)', textTransform: 'uppercase' }}>
                  {item.period}
                </div>
              </div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'var(--ink-mid)', fontWeight: 300, marginBottom: '8px' }}>
                {item.org}
              </div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', color: 'var(--ink-light)', fontStyle: 'italic', fontWeight: 300, lineHeight: 1.6 }}>
                {item.note}
              </div>
              {item.period === 'Current' && (
                <div style={{ position: 'absolute', top: '28px', left: '12px', width: '3px', height: '20px', background: 'var(--accent)', borderRadius: '1px' }} />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
